// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";

// import DropdownSelectedValue from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
// import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import SuccessImg from ".././../../Assets/Images/CommanImages/Informative.png";

// function UpdatedCreateUserGroup({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { sessionsData } = useSelector((state) => state.sessions);

//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [subjects, setSubjects] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [subjectDropdownKey, setSubjectDropdownKey] = useState(Date.now()); // key to force remount
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [studentGroupName, setStudentGroupName] = useState("");
//   const [studentGroupDesc, setStudentGroupDesc] = useState("");
//   const [comments, setComments] = useState("");
//   const [selectedReviewerGroup, setSelectedReviewerGroup] = useState(2);
//   const [selectedReviewerType, setSelectedReviewerType] = useState(null);
//   const [selectedReviewerLevel, setSelectedReviewerLevel] = useState(null);
//   const [reviewerDropdownKey, setReviewerDropdownKey] = useState(Date.now());

//   const [selectedEmailFlag, setSelectedEmailFlag] = useState(null);
//   const [selectedMessageFlag, setSelectedMessageFlag] = useState(null);

//   // Add Employees (table) options & selection
//   const [employeeSearchOptions, setEmployeeSearchOptions] = useState([]); // options containing emp_id as id
//   const [selectedEmployees, setSelectedEmployees] = useState([]);

//   // Owner dropdown options (owner uses user_id as id)
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   const [selectedEmployeeCoordinator, setSelectedEmployeeCoordinator] = useState(null);

//   const [branchOptions, setBranchOptions] = useState([]);
//   const [selectedBranches, setSelectedBranches] = useState([]);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   // UI states
//   const [isOpenGroupInfo, setIsOpenGroupInfo] = useState(true);
//   const toggleAccordionGroupInfo = () => setIsOpenGroupInfo((s) => !s);
//   const [isOpenReviewerGroup, setIsOpenReviewerGroup] = useState(true);
//   const toggleAccordionReviewerGroup = () => setIsOpenReviewerGroup((s) => !s);
//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const toggleAccordionShareBranch = () => setIsOpenShareBranch(!isOpenShareBranch);

//   const isUpdatingFromTable = useRef(false);

//   useEffect(() => {
//     dispatch(fetchCourseData());
//     dispatch(fetchSessionData());
//   }, [dispatch]);

//   // --- SUBJECT FETCH: when course changes, fetch subjects & clear selection
//   useEffect(() => {
//     if (selectedCourse) {
//       // clear selection immediately so UI updates right away
//       setSelectedSubjects([]);
//       // force a remount of Subject dropdown to avoid internal cached value
//       setSubjectDropdownKey(Date.now());
//       fetch(`${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourse}`)
//         .then((res) => res.json())
//         .then((data) => {
//           const fetchedSubjects = data || [];
//           setSubjects(fetchedSubjects);
//           // don't auto-select a subject — user must pick
//         })
//         .catch((err) => console.error("Error fetching subjects:", err));
//     } else {
//       setSubjects([]);
//       setSelectedSubjects([]);
//       setSubjectDropdownKey(Date.now()); // also remount when clearing course
//     }
//   }, [selectedCourse]);

//   // OWNER dropdown (Select Group Owner Name)
//   // owner option id will be user_id (so we send user_id on save)
//   const fetchEmployeeCoordinator = (searchKey) => {
//     if (!searchKey || String(searchKey).trim().length === 0) {
//       // keep existing options but don't clear them — user can still select existing placeholder if any
//       return;
//     }
//     fetch(
//       `${FULL_API_BASE_URL}/get-employee-by-search-key/?search_key=${encodeURIComponent(
//         searchKey
//       )}`,
//       {
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         const arr = Array.isArray(data) ? data : [];
//         const opts = arr
//           .filter((emp) => emp.user_id !== null) // only employees who have an app user
//           .map((emp) => ({
//             id: emp.user_id ?? emp.emp_id,
//             label: `${[emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
//               .filter(Boolean)
//               .join(" ")} / ${emp.staff_number || "N/A"} / ${emp.department || "N/A"}`,
//             fullData: emp,
//           }));
//         // Replace employeeOptions fully for owner (owner dropdown concerns user accounts only)
//         setEmployeeOptions(opts);
//       })
//       .catch((err) => {
//         console.error("Error fetching employee coordinator:", err);
//         // keep existing options on error
//       });
//   };

//   // ADD EMPLOYEES fetcher — REMOVED faculty_flag filter and NOW MERGES results with existing options
//   const fetchEmployeesForGroup = (searchKey) => {
//     // If searchKey is empty -> do nothing (keep existing options and selected items)
//     if (!searchKey || String(searchKey).trim().length === 0) {
//       return;
//     }

//     fetch(
//       `${FULL_API_BASE_URL}/search-emp-for-group?client_branch_id=${clientBranchId}&search_key=${encodeURIComponent(
//         searchKey
//       )}`,
//       {
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         const arr = Array.isArray(data?.data) ? data.data : [];
//         const newOpts = arr.map((emp) => ({
//           id: emp.emp_id,
//           label: `${emp.employee_name?.replace(/^,\s*/, "") || "---"} / ${emp.staff_number || "N/A"} / ${emp.department_name || "N/A"} / ${emp.designation_name || "N/A"}`,
//           fullData: emp,
//         }));

//         // Merge: keep new results first, then append previous options that are not duplicates.
//         setEmployeeSearchOptions((prev = []) => {
//           const map = new Map();
//           // add new opts first (so they appear at top)
//           newOpts.forEach((n) => map.set(String(n.id), n));
//           // append previous options if they aren't in the new set
//           prev.forEach((p) => {
//             if (!map.has(String(p.id))) map.set(String(p.id), p);
//           });
//           return Array.from(map.values());
//         });
//       })
//       .catch((err) => {
//         console.error("Error fetching employees:", err);
//       });
//   };

//   // many unchanged helpers: branches, table data, etc.
//   const clientBranchNum = clientBranchId ? Number(clientBranchId) : null;

//   useEffect(() => {
//     const resolvedClientId =
//       clientBranchId ||
//       (() => {
//         try {
//           const stored = localStorage.getItem("client_branch_id");
//           return stored ? Number(stored) : null;
//         } catch (e) {
//           return null;
//         }
//       })();

//     if (!resolvedClientId) {
//       return;
//     }

//     const fetchBranches = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-branch-list?client_id=${resolvedClientId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const json = await res.json();

//         if (json && json.status === 200 && Array.isArray(json.data)) {
//           const opts = json.data.map((b) => ({
//             label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
//             id: b.branch_id,
//             disabled: Number(b.branch_id) === clientBranchNum,
//           }));
//           setBranchOptions(opts);
//         } else {
//           setBranchOptions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching branches:", err);
//         setBranchOptions([]);
//       }
//     };

//     fetchBranches();
//   }, [clientBranchId, dataClient, clientBranchNum]);

//   const headers = [
//     "Employee ID",
//     "Employee Name",
//     "Staff Number",
//     "Department",
//     "Designation",
//     "Branch",
//     "App User Flag",
//     "Faculty Flag",
//   ];

//   // When generating table rows, find the option in employeeSearchOptions by emp_id
//   const tableData = (Array.isArray(selectedEmployees) ? selectedEmployees : [])
//     .map((empId) => {
//       const opt = employeeSearchOptions.find((o) => String(o.id) === String(empId));
//       if (!opt || !opt.fullData) return null;
//       const e = opt.fullData;
//       return [
//         empId,
//         e.employee_name?.replace(/^,\s*/, "") || "---",
//         e.staff_number || "---",
//         e.department_name || "---",
//         e.designation_name || "---",
//         e.branch_name || "---",
//         e.app_user_flag ? "Yes" : "No",
//         e.faculty_flag ? "Yes" : "No",
//       ];
//     })
//     .filter(Boolean);

//   const handleTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromTable.current = true;
//     setSelectedEmployees(newSelectedRows);
//     setTimeout(() => {
//       isUpdatingFromTable.current = false;
//     }, 0);
//   };

//   const handleDeleteRow = (rowId) => {
//     setEmployeeSearchOptions((prev) => prev.filter((o) => String(o.id) !== String(rowId)));
//     setSelectedEmployees((prev) => prev.filter((id) => String(id) !== String(rowId)));
//   };

//   const handleSetSelectedBranches = (vals) => {
//     const filtered = Array.isArray(vals)
//       ? vals.filter((v) => Number(v) !== clientBranchNum)
//       : [];
//     setSelectedBranches(filtered);
//   };

//   // --- NEW: when HOD is selected (selectedReviewerType === 1), clear reviewer level ---
//   useEffect(() => {
//     if (selectedReviewerType === 1) {
//       setSelectedReviewerLevel(null);
//     }
//   }, [selectedReviewerType]);

//   // ======= VALIDATION RULES (modified as requested) =======
//   // User Group Name:
//   //  - max 100 while typing
//   //  - allowed chars while typing: letters, numbers, space, '-' and '_' (spaces anywhere allowed)
//   //  - first char must not be a digit (validation checked during typing and on save)
//   const groupNameAllowedRegex = /^[A-Za-z0-9 _-]*$/; // while typing (allows empty string)
//   const groupNameFirstCharNotDigitRegex = /^(?!\d)[A-Za-z0-9 _-].*$/; // ensures first char not digit and at least 1 char
//   // User Group Description:
//   //  - max 500 while typing
//   //  - allow letters, numbers, spaces and a broad set of punctuation/special chars
//   const groupDescAllowedRegex = /^[A-Za-z0-9\s\-\_.,'"\(\)\?!:;@#\$%&\*\+=\[\]\{\}<>\/\\`~]*$/;

//   const [groupNameValid, setGroupNameValid] = useState(true);
//   const [groupDescValid, setGroupDescValid] = useState(true);

//   // IMPORTANT: do NOT trim leading/trailing spaces while typing.
//   // Trim only on save (handleSaveUserGroup).
//   const onGroupNameChange = (e) => {
//     let val = e.target.value || "";

//     // Enforce max length while typing
//     if (val.length > 100) {
//       val = val.slice(0, 100);
//     }

//     // Keep the exact spaces the user types (including leading/trailing and multiples)
//     setStudentGroupName(val);

//     // Run live validations (do NOT trim here)
//     // 1) Allowed characters
//     const allowed = groupNameAllowedRegex.test(val);
//     // 2) If non-empty, check first char not digit
//     const firstNotDigit = val === "" ? true : groupNameFirstCharNotDigitRegex.test(val);
//     const isValid = allowed && firstNotDigit && val.length <= 100;
//     setGroupNameValid(isValid);
//   };

//   const onGroupDescChange = (e) => {
//     let val = e.target.value || "";

//     // Enforce max length while typing
//     if (val.length > 500) {
//       val = val.slice(0, 500);
//     }

//     // Keep spaces as typed (including leading/trailing and multiples)
//     setStudentGroupDesc(val);

//     // Live validation: allowed chars and length (no trimming)
//     const allowed = groupDescAllowedRegex.test(val);
//     const isValid = allowed && val.length <= 500;
//     setGroupDescValid(isValid);
//   };

//   const showValidationMessage = (text) => {
//     if (setMessageBox) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{text}</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     } else {
//       console.warn("Validation:", text);
//     }
//   };

//   const handleSaveUserGroup = async () => {
//     try {
//       // Trim only on save (leading/trailing)
//       const groupNameTrimmed = (studentGroupName || "").trim();
//       const groupDescTrimmed = (studentGroupDesc || "").trim();
//       const commentsTrimmed = (comments || "").trim();

//       // Re-validate on trimmed values as final guard

//       // Group name checks:

//       if (!groupNameTrimmed) {
//         setGroupNameValid(false);
//         showValidationMessage("User Group Name is required.");
//         return;
//       }
//       if (groupNameTrimmed.length > 100) {
//         setGroupNameValid(false);
//         showValidationMessage("User Group Name must be at most 100 characters.");
//         return;
//       }
//       if (!/^[A-Za-z0-9 _-]+$/.test(groupNameTrimmed)) {
//         setGroupNameValid(false);
//         showValidationMessage("User Group Name contains invalid characters. Only letters, numbers, space, '-' and '_' are allowed.");

//         return;
//       }
//       if (!/^(?!\d)/.test(groupNameTrimmed)) {
//         setGroupNameValid(false);
//         showValidationMessage("User Group Name must not start with a number.");
//         return;
//       }
//       setGroupNameValid(true);

//       // Group description checks:
//       if (!groupDescTrimmed) {
//         setGroupDescValid(false);
//         showValidationMessage("User Group Description is required.");
//         return;
//       }
//       if (groupDescTrimmed.length > 500) {
//         setGroupDescValid(false);
//         showValidationMessage("User Group Description must be at most 500 characters.");
//         return;
//       }

//       if (!groupDescAllowedRegex.test(groupDescTrimmed)) {
//         setGroupDescValid(false);
//         showValidationMessage("User Group Description contains invalid characters.");
//         return;
//       }
//       setGroupDescValid(true);

//       // Ensure owner selected

//       if (!selectedEmployeeCoordinator) {
//         showValidationMessage("Please fill all required fields before saving.");
//         return;
//       }

//       const token = localStorage.getItem("other");

//       const user_members = selectedEmployees
//         .map((empId) => {
//           const empObj =
//             employeeSearchOptions.find((e) => String(e.id) === String(empId)) ||
//             employeeOptions.find((e) => String(e.id) === String(empId));
//           if (!empObj || !empObj.fullData) return null;
//           return {
//             emp_id: empObj.fullData.emp_id,
//             user_id: empObj.fullData.user_id || 0,
//           };
//         })
//         .filter(Boolean);

//       // Validate at least one employee present
//       if (!Array.isArray(user_members) || user_members.length === 0) {
//         showValidationMessage("Please add at least one employee to the group.");
//         return;
//       }

//       const isReviewer = selectedReviewerGroup === 1;

//       const payload = {
//         user_members,
//         is_ques_reviewer_grp: isReviewer,
//         course_id: selectedCourse || 0,
//         subject_id:
//           Array.isArray(selectedSubjects) && selectedSubjects.length > 0
//             ? selectedSubjects[0]
//             : 0,
//         hod_or_faculty:
//           selectedReviewerType === 1 ? "hod" : selectedReviewerType === 2 ? "faculty" : "",
//         reviewer_level: selectedReviewerLevel || 0,
//       };

//       // Add comments to payload only if trimmed comments are non-empty (no spaces-only)
//       if (commentsTrimmed.length > 0) {
//         payload.comments = commentsTrimmed;
//       }

//       // selectedEmployeeCoordinator holds user_id (owner dropdown uses user_id)
//       const queryParams = new URLSearchParams({
//         group_name: groupNameTrimmed,
//         group_desc: groupDescTrimmed,
//         group_owner_user_id: selectedEmployeeCoordinator,
//         client_id: clientId,
//         client_branch_id: clientBranchId,
//         email_flag: selectedEmailFlag || 0,
//         message_flag: selectedMessageFlag || 0,
//         user_name: userName || "system",
//       });

//       const response = await fetch(
//         `${FULL_API_BASE_URL}/create-user-group?${queryParams.toString()}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             accept: "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const data = await response.json();

//       if (response.ok && data?.status === 200) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>User Group created successfully!</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setTimeout(() => {
//           navigate("/user_groups_dashboard");
//           window.location.reload();
//         }, 1500);
//       } else {
//         throw new Error(data?.message || "Failed to create user group");
//       }
//     } catch (error) {
//       console.error("Error creating user group:", error);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Something went wrong. Please try again.</span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//       }
//     }
//   };

//   // handleCourseSelect: clear subject and force subject dropdown remount
//   const handleCourseSelect = (val) => {
//     setSelectedCourse(val);
//     setSelectedSubjects([]); // clear selected subject immediately
//     setSubjectDropdownKey(Date.now()); // force remount so dropdown can't hold previous value internally
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Create User Group</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/user_groups_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSaveUserGroup}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* GROUP INFORMATION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>GROUP INFROMATION</label>
//           </div>
//           <div
//             className="accordion-btn"
//             onClick={toggleAccordionGroupInfo}
//             style={{ cursor: "pointer" }}
//             title={isOpenGroupInfo ? "Minimize" : "Expand"}
//           >
//             {isOpenGroupInfo ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenGroupInfo && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <FormInputs
//                     label="User Group Name"
//                     type="text"
//                     value={studentGroupName}
//                     onChange={onGroupNameChange}
//                     required
//                     className={!groupNameValid ? "input-error" : ""}
//                     inputClassName={!groupNameValid ? "input-error" : ""}
//                     style={!groupNameValid ? { border: "1px solid red" } : {}}
//                     maxLength={100}
//                   />
//                 </div>

//                 <div className="item2">
//                   <FormInputs
//                     label="User Group Description"
//                     type="text"
//                     value={studentGroupDesc}
//                     onChange={onGroupDescChange}
//                     required
//                     className={!groupDescValid ? "input-error" : ""}
//                     inputClassName={!groupDescValid ? "input-error" : ""}
//                     style={!groupDescValid ? { border: "1px solid red" } : {}}
//                     maxLength={500}
//                   />
//                 </div>

//                 <div className="item3">
//                   <DropDown
//                     label="Message Flag"
//                     selected={selectedMessageFlag}
//                     setSelected={setSelectedMessageFlag}
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     isRequired={true}
//                   />
//                 </div>

//                 <div className="item4">
//                   <DropDown
//                     label="Email Flag"
//                     selected={selectedEmailFlag}
//                     setSelected={setSelectedEmailFlag}
//                     options={[
//                       { id: 1, label: "True" },
//                       { id: 0, label: "False" },
//                     ]}
//                     isRequired={true}
//                   />
//                 </div>

//                 <div className="item5">
//                   <SingleSelectSearchDropdown
//                     label="Select Group Owner Name"
//                     width="100%"
//                     singleSelect={true}
//                     selected={selectedEmployeeCoordinator}
//                     setSelected={setSelectedEmployeeCoordinator}
//                     options={employeeOptions}
//                     placeholder="Search and Select Group Owner Name..."
//                     onSearchInputChange={fetchEmployeeCoordinator}
//                     isRequired={true}
//                   />
//                 </div>

//                 <div className="item6">
//                   <FormInputs
//                     label="Comments"
//                     type="text"
//                     value={comments}
//                     onChange={(e) => setComments(e.target.value)}
//                     required={false}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* QUESTION REVIEWER GROUP */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION REVIEWER GROUP</label>
//           </div>
//           <div
//             className="accordion-btn"
//             onClick={toggleAccordionReviewerGroup}
//             style={{ cursor: "pointer" }}
//             title={isOpenReviewerGroup ? "Minimize" : "Expand"}
//           >
//             {isOpenReviewerGroup ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenReviewerGroup && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <DropdownSelectedValue
//                     label="Is this a Question Reviewer Group?"
//                     selected={selectedReviewerGroup || 2}
//                     setSelected={(value) => {
//                       setSelectedReviewerGroup(value);
//                       if (value === 2) {
//                         setSelectedCourse(null);
//                         setSelectedSubjects([]);
//                         setSelectedReviewerType(null);
//                         setSelectedReviewerLevel(null);
//                         setReviewerDropdownKey(Date.now());
//                         setSubjectDropdownKey(Date.now()); // also remount subject
//                       }
//                     }}
//                     options={[
//                       { label: "Yes", id: 1 },
//                       { label: "No", id: 2 },
//                     ]}
//                     isRequired={true}
//                   />
//                 </div>

//                 <div className="item2">
//                   <DropDown
//                     key={`course-${reviewerDropdownKey}`}
//                     label="Course"
//                     selected={selectedReviewerGroup === 2 ? null : selectedCourse}
//                     setSelected={handleCourseSelect}
//                     options={
//                       Array.isArray(coursesdata)
//                         ? coursesdata.map((course) => ({
//                             label: course.course_name,
//                             id: course.course_id,
//                           }))
//                         : []
//                     }
//                     isRequired={true}
//                     disabled={selectedReviewerGroup === 2}
//                   />
//                 </div>

//                 <div className="item3">
//                   <DropDown
//                     key={`subject-${subjectDropdownKey}`}
//                     label="Subject"
//                     selected={
//                       selectedReviewerGroup === 2
//                         ? null
//                         : Array.isArray(selectedSubjects) && selectedSubjects.length > 0
//                         ? selectedSubjects[0]
//                         : null
//                     }
//                     setSelected={(val) => setSelectedSubjects(val ? [val] : [])}
//                     options={
//                       Array.isArray(subjects)
//                         ? subjects.map((subj) => ({
//                             label: subj.subject_name,
//                             id: subj.subject_id,
//                           }))
//                         : []
//                     }
//                     isRequired={true}
//                     disabled={selectedReviewerGroup === 2}
//                   />
//                 </div>

//                 <div className="item4">
//                   {/* <DropDown
//                     key={`reviewer-type-${reviewerDropdownKey}`}
//                     label="HOD or Faculty Reviewer Group?"
//                     selected={selectedReviewerGroup === 2 ? null : selectedReviewerType}
//                     setSelected={setSelectedReviewerType}
//                     options={[
//                       { label: "HOD", id: 1 },
//                       { label: "Faculty", id: 2 },
//                     ]}
//                     isRequired={true}
//                     disabled={selectedReviewerGroup === 2}
//                   /> */}
//                   <DropDown
//   key={`reviewer-type-${reviewerDropdownKey}`}
//   label="HOD or Faculty Reviewer Group?"
//   selected={selectedReviewerGroup === 2 ? null : selectedReviewerType}
//   setSelected={(val) => {
//     // set the type normally
//     setSelectedReviewerType(val);
//     // clear level when HOD
//     if (val === 1) {
//       setSelectedReviewerLevel(null);
//     }
//     // << DO NOT call setReviewerDropdownKey here >>
//   }}
//   options={[
//     { label: "HOD", id: 1 },
//     { label: "Faculty", id: 2 },
//   ]}
//   isRequired={true}
//   disabled={selectedReviewerGroup === 2}
// />

//                 </div>

//                 <div className="item5">
//                   {/* <DropDown
//                     key={`reviewer-level-${reviewerDropdownKey}`}
//                     label="Reviewer Level"
//                     selected={selectedReviewerGroup === 2 ? null : selectedReviewerLevel}
//                     setSelected={setSelectedReviewerLevel}
//                     options={[
//                       { label: "1", id: 1 },
//                       { label: "2", id: 2 },
//                       { label: "3", id: 3 },
//                     ]}
//                     isRequired={true}
//                     disabled={selectedReviewerGroup === 2 || selectedReviewerType === 1}
//                   /> */}
//                   <DropDown
//   key={`reviewer-level-${reviewerDropdownKey}-${selectedReviewerType}`}
//   label="Reviewer Level"
//   selected={
//     selectedReviewerGroup === 2
//       ? null
//       : selectedReviewerType === 1
//       ? null
//       : selectedReviewerLevel
//   }
//   setSelected={setSelectedReviewerLevel}
//   options={[
//     { label: "1", id: 1 },
//     { label: "2", id: 2 },
//     { label: "3", id: 3 },
//   ]}
//   isRequired={true}
//   disabled={selectedReviewerGroup === 2 || selectedReviewerType === 1}
// />

//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* MANAGE EMPLOYEE */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>MANAGE EMPLOYEE</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>
//         {isOpenShareBranch && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "20px 0px 20px 10px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <DropdownWithPagination
//                     label="Add Employees"
//                     width="100%"
//                     selected={selectedEmployees}
//                     setSelected={setSelectedEmployees}
//                     onSearchInputChange={fetchEmployeesForGroup}
//                     options={employeeSearchOptions}
//                     isRequired={true}
//                     showSelectAll={false}
//                     itemsPerPage={4}
//                   />
//                 </div>

//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headers}
//                     data={tableData}
//                     searchPlaceholder="Search employees..."
//                     selectedRows={selectedEmployees}
//                     setSelectedRows={handleTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRow}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UpdatedCreateUserGroup;

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import DropdownSelectedValue from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { fetchSessionData } from "../../../Redux/Sessions/sessionSlice";
import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import SuccessImg from ".././../../Assets/Images/CommanImages/Informative.png";

function UpdatedCreateUserGroup({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const { sessionsData } = useSelector((state) => state.sessions);

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectDropdownKey, setSubjectDropdownKey] = useState(Date.now()); // key to force remount
  const [selectedSession, setSelectedSession] = useState(null);
  const [studentGroupName, setStudentGroupName] = useState("");
  const [studentGroupDesc, setStudentGroupDesc] = useState("");
  const [comments, setComments] = useState("");
  const [selectedReviewerGroup, setSelectedReviewerGroup] = useState(2);
  const [selectedReviewerType, setSelectedReviewerType] = useState(null);
  const [selectedReviewerLevel, setSelectedReviewerLevel] = useState(null);
  const [reviewerDropdownKey, setReviewerDropdownKey] = useState(Date.now());

  const [selectedEmailFlag, setSelectedEmailFlag] = useState(null);
  const [selectedMessageFlag, setSelectedMessageFlag] = useState(null);

  // Add Employees (table) options & selection
  const [employeeSearchOptions, setEmployeeSearchOptions] = useState([]); // options containing emp_id as id
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  // Owner dropdown options (owner uses user_id as id)
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployeeCoordinator, setSelectedEmployeeCoordinator] =
    useState(null);

  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const accessToken = localStorage.getItem("other");

  // UI states
  const [isOpenGroupInfo, setIsOpenGroupInfo] = useState(true);
  const toggleAccordionGroupInfo = () => setIsOpenGroupInfo((s) => !s);
  const [isOpenReviewerGroup, setIsOpenReviewerGroup] = useState(true);
  const toggleAccordionReviewerGroup = () => setIsOpenReviewerGroup((s) => !s);
  const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
  const toggleAccordionShareBranch = () =>
    setIsOpenShareBranch(!isOpenShareBranch);

  const isUpdatingFromTable = useRef(false);

  useEffect(() => {
    dispatch(fetchCourseData());
    dispatch(fetchSessionData());
  }, [dispatch]);

  // --- SUBJECT FETCH: when course changes, fetch subjects & clear selection
  useEffect(() => {
    if (selectedCourse) {
      // clear selection immediately so UI updates right away
      setSelectedSubjects([]);
      // force a remount of Subject dropdown to avoid internal cached value
      setSubjectDropdownKey(Date.now());
      fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourse}`
      )
        .then((res) => res.json())
        .then((data) => {
          const fetchedSubjects = data || [];
          setSubjects(fetchedSubjects);
          // don't auto-select a subject — user must pick
        })
        .catch((err) => console.error("Error fetching subjects:", err));
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
      setSubjectDropdownKey(Date.now()); // also remount when clearing course
    }
  }, [selectedCourse]);

  // OWNER dropdown (Select Group Owner Name)
  // owner option id will be user_id (so we send user_id on save)
  const fetchEmployeeCoordinator = (searchKey) => {
    if (!searchKey || String(searchKey).trim().length === 0) {
      return;
    }

    fetch(
      `${FULL_API_BASE_URL}/search-emp-for-group?client_branch_id=${clientBranchId}&search_key=${encodeURIComponent(
        searchKey
      )}`,
      {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((json) => {
        const arr = Array.isArray(json?.data)
          ? json.data
          : Array.isArray(json)
          ? json
          : [];
        const opts = arr
          .filter(
            (emp) =>
              emp && emp.user_id !== null && typeof emp.user_id !== "undefined"
          )
          .map((emp) => {
            // Build display name robustly: prefer employee_name if available,
            // otherwise join first/middle/last. Keep staff_number & department fallback.
            const name =
              emp.employee_name && String(emp.employee_name).trim() !== ""
                ? emp.employee_name
                : [emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
                    .filter(Boolean)
                    .join(" ");

            const department = emp.department_name || emp.department || "N/A";
            const staffNum = emp.staff_number || "N/A";

            return {
              id: emp.user_id ?? emp.emp_id,
              label: `${name || "---"} / ${staffNum} / ${department}`,
              fullData: emp,
            };
          });

        setEmployeeOptions(opts);
      })
      .catch((err) => {
        console.error(
          "Error fetching employee coordinator (swapped API):",
          err
        );
        // keep existing options on error
      });
  };

  // ADD EMPLOYEES fetcher — NOW calls get-employee-by-search-key (swapped),
  // maps results to employeeSearchOptions shape and MERGES with existing options.
  const fetchEmployeesForGroup = (searchKey) => {
    if (!searchKey || String(searchKey).trim().length === 0) {
      return;
    }

    fetch(
      `${FULL_API_BASE_URL}/get-employee-by-search-key/?search_key=${encodeURIComponent(
        searchKey
      )}`
    )
      .then((res) => res.json())
      .then((arrRaw) => {
        // get-employee-by-search-key previously returned an array of employees directly
        const arr = Array.isArray(arrRaw)
          ? arrRaw
          : Array.isArray(arrRaw?.data)
          ? arrRaw.data
          : [];
        const newOpts = arr.map((emp) => ({
          id: emp.emp_id,
          label: `${
            emp.employee_name?.replace(/^,\s*/, "") ||
            (emp.emp_first_name
              ? [emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
                  .filter(Boolean)
                  .join(" ")
              : "---")
          } / ${emp.staff_number || "N/A"} / ${
            emp.department || emp.department_name || "N/A"
          } / ${emp.designation || emp.designation_name || "N/A"}`,
          fullData: emp,
        }));

        // Merge: keep new results first, then append previous options that are not duplicates.
        setEmployeeSearchOptions((prev = []) => {
          const map = new Map();
          // add new opts first (so they appear at top)
          newOpts.forEach((n) => map.set(String(n.id), n));
          // append previous options if they aren't in the new set
          prev.forEach((p) => {
            if (!map.has(String(p.id))) map.set(String(p.id), p);
          });
          return Array.from(map.values());
        });
      })
      .catch((err) => {
        console.error("Error fetching employees for group (swapped API):", err);
      });
  };

  // many unchanged helpers: branches, table data, etc.
  const clientBranchNum = clientBranchId ? Number(clientBranchId) : null;

  useEffect(() => {
    const resolvedClientId =
      clientBranchId ||
      (() => {
        try {
          const stored = localStorage.getItem("client_branch_id");
          return stored ? Number(stored) : null;
        } catch (e) {
          return null;
        }
      })();

    if (!resolvedClientId) {
      return;
    }

    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem("other");
        const res = await fetch(
          `${FULL_API_BASE_URL}/get-branch-list?client_id=${resolvedClientId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const json = await res.json();

        if (json && json.status === 200 && Array.isArray(json.data)) {
          const opts = json.data.map((b) => ({
            label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
            id: b.branch_id,
            disabled: Number(b.branch_id) === clientBranchNum,
          }));
          setBranchOptions(opts);
        } else {
          setBranchOptions([]);
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
        setBranchOptions([]);
      }
    };

    fetchBranches();
  }, [clientBranchId, dataClient, clientBranchNum]);

  const headers = [
    "Employee ID",
    "Employee Name",
    "Staff Number",
    "Department",
    "Designation",
    "Branch",
    "App User Flag",
    "Faculty Flag",
  ];

  // When generating table rows, find the option in employeeSearchOptions by emp_id
  const tableData = (Array.isArray(selectedEmployees) ? selectedEmployees : [])
    .map((empId) => {
      const opt = employeeSearchOptions.find(
        (o) => String(o.id) === String(empId)
      );
      if (!opt || !opt.fullData) return null;
      const e = opt.fullData;
      return [
        empId,
        e.employee_name?.replace(/^,\s*/, "") ||
          (e.emp_first_name
            ? [e.emp_first_name, e.emp_middle_name, e.emp_last_name]
                .filter(Boolean)
                .join(" ")
            : "---"),
        e.staff_number || "---",
        e.department_name || e.department || "---",
        e.designation_name || e.designation || "---",
        e.branch_name || "---",
        e.app_user_flag ? "Yes" : "No",
        e.faculty_flag ? "Yes" : "No",
      ];
    })
    .filter(Boolean);

  const handleTableRowSelection = (newSelectedRows) => {
    isUpdatingFromTable.current = true;
    setSelectedEmployees(newSelectedRows);
    setTimeout(() => {
      isUpdatingFromTable.current = false;
    }, 0);
  };

  const handleDeleteRow = (rowId) => {
    setEmployeeSearchOptions((prev) =>
      prev.filter((o) => String(o.id) !== String(rowId))
    );
    setSelectedEmployees((prev) =>
      prev.filter((id) => String(id) !== String(rowId))
    );
  };

  const handleSetSelectedBranches = (vals) => {
    const filtered = Array.isArray(vals)
      ? vals.filter((v) => Number(v) !== clientBranchNum)
      : [];
    setSelectedBranches(filtered);
  };

  // --- NEW: when HOD is selected (selectedReviewerType === 1), clear reviewer level ---
  useEffect(() => {
    if (selectedReviewerType === 1) {
      setSelectedReviewerLevel(null);
    }
  }, [selectedReviewerType]);

  // ======= VALIDATION RULES (modified as requested) =======
  // User Group Name:
  //  - max 100 while typing
  //  - allowed chars while typing: letters, numbers, space, '-' and '_' (spaces anywhere allowed)
  //  - first char must not be a digit (validation checked during typing and on save)
  const groupNameAllowedRegex = /^[A-Za-z0-9 _-]*$/; // while typing (allows empty string)
  const groupNameFirstCharNotDigitRegex = /^(?!\d)[A-Za-z0-9 _-].*$/; // ensures first char not digit and at least 1 char
  // User Group Description:
  //  - max 500 while typing
  //  - allow letters, numbers, spaces and a broad set of punctuation/special chars
  const groupDescAllowedRegex =
    /^[A-Za-z0-9\s\-\_.,'"\(\)\?!:;@#\$%&\*\+=\[\]\{\}<>\/\\`~]*$/;

  const [groupNameValid, setGroupNameValid] = useState(true);
  const [groupDescValid, setGroupDescValid] = useState(true);

  // IMPORTANT: do NOT trim leading/trailing spaces while typing.
  // Trim only on save (handleSaveUserGroup).
  const onGroupNameChange = (e) => {
    let val = e.target.value || "";

    // Enforce max length while typing
    if (val.length > 100) {
      val = val.slice(0, 100);
    }

    // Keep the exact spaces the user types (including leading/trailing and multiples)
    setStudentGroupName(val);

    // Run live validations (do NOT trim here)
    // 1) Allowed characters
    const allowed = groupNameAllowedRegex.test(val);
    // 2) If non-empty, check first char not digit
    const firstNotDigit =
      val === "" ? true : groupNameFirstCharNotDigitRegex.test(val);
    const isValid = allowed && firstNotDigit && val.length <= 100;
    setGroupNameValid(isValid);
  };

  const onGroupDescChange = (e) => {
    let val = e.target.value || "";

    // Enforce max length while typing
    if (val.length > 500) {
      val = val.slice(0, 500);
    }

    // Keep spaces as typed (including leading/trailing and multiples)
    setStudentGroupDesc(val);

    // Live validation: allowed chars and length (no trimming)
    const allowed = groupDescAllowedRegex.test(val);
    const isValid = allowed && val.length <= 500;
    setGroupDescValid(isValid);
  };

  const showValidationMessage = (text) => {
    if (setMessageBox) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{text}</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    } else {
      console.warn("Validation:", text);
    }
  };

  const handleSaveUserGroup = async () => {
    try {
      // Trim only on save (leading/trailing)
      const groupNameTrimmed = (studentGroupName || "").trim();
      const groupDescTrimmed = (studentGroupDesc || "").trim();
      const commentsTrimmed = (comments || "").trim();

      // Re-validate on trimmed values as final guard

      // Group name checks:
      if (!groupNameTrimmed) {
        setGroupNameValid(false);
        showValidationMessage("User Group Name is required.");
        return;
      }
      if (groupNameTrimmed.length > 100) {
        setGroupNameValid(false);
        showValidationMessage(
          "User Group Name must be at most 100 characters."
        );
        return;
      }
      if (!/^[A-Za-z0-9 _-]+$/.test(groupNameTrimmed)) {
        setGroupNameValid(false);
        showValidationMessage(
          "User Group Name contains invalid characters. Only letters, numbers, space, '-' and '_' are allowed."
        );
        return;
      }
      if (!/^(?!\d)/.test(groupNameTrimmed)) {
        setGroupNameValid(false);
        showValidationMessage("User Group Name must not start with a number.");
        return;
      }
      setGroupNameValid(true);

      // Group description checks:
      if (!groupDescTrimmed) {
        setGroupDescValid(false);
        showValidationMessage("User Group Description is required.");
        return;
      }
      if (groupDescTrimmed.length > 500) {
        setGroupDescValid(false);
        showValidationMessage(
          "User Group Description must be at most 500 characters."
        );
        return;
      }
      if (!groupDescAllowedRegex.test(groupDescTrimmed)) {
        setGroupDescValid(false);
        showValidationMessage(
          "User Group Description contains invalid characters."
        );
        return;
      }
      setGroupDescValid(true);

      // Ensure owner selected
      if (!selectedEmployeeCoordinator) {
        showValidationMessage("Please fill all required fields before saving.");
        return;
      }

      const token = localStorage.getItem("other");

      const user_members = selectedEmployees
        .map((empId) => {
          const empObj =
            employeeSearchOptions.find((e) => String(e.id) === String(empId)) ||
            employeeOptions.find((e) => String(e.id) === String(empId));
          if (!empObj || !empObj.fullData) return null;
          return {
            emp_id: empObj.fullData.emp_id,
            user_id: empObj.fullData.user_id || 0,
          };
        })
        .filter(Boolean);

      // Validate at least one employee present
      if (!Array.isArray(user_members) || user_members.length === 0) {
        showValidationMessage("Please add at least one employee to the group.");
        return;
      }

      const isReviewer = selectedReviewerGroup === 1;

      const payload = {
        user_members,
        is_ques_reviewer_grp: isReviewer,
        course_id: selectedCourse || 0,
        subject_id:
          Array.isArray(selectedSubjects) && selectedSubjects.length > 0
            ? selectedSubjects[0]
            : 0,
        hod_or_faculty:
          selectedReviewerType === 1
            ? "hod"
            : selectedReviewerType === 2
            ? "faculty"
            : "",
        reviewer_level: selectedReviewerLevel || 0,
      };

      // Add comments to payload only if trimmed comments are non-empty (no spaces-only)
      if (commentsTrimmed.length > 0) {
        payload.comments = commentsTrimmed;
      }

      // selectedEmployeeCoordinator holds user_id (owner dropdown uses user_id)
      const queryParams = new URLSearchParams({
        group_name: groupNameTrimmed,
        group_desc: groupDescTrimmed,
        group_owner_user_id: selectedEmployeeCoordinator,
        client_id: clientId,
        client_branch_id: clientBranchId,
        email_flag: selectedEmailFlag || 0,
        message_flag: selectedMessageFlag || 0,
        user_name: userName || "system",
      });

      const response = await fetch(
        `${FULL_API_BASE_URL}/create-user-group?${queryParams.toString()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok && data?.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>User Group created successfully!</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setTimeout(() => {
          navigate("/user_groups_dashboard");
          window.location.reload();
        }, 1500);
      } else {
        throw new Error(data?.message || "Failed to create user group");
      }
    } catch (error) {
      console.error("Error creating user group:", error);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Something went wrong. Please try again.</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    }
  };

  // handleCourseSelect: clear subject and force subject dropdown remount
  const handleCourseSelect = (val) => {
    setSelectedCourse(val);
    setSelectedSubjects([]); // clear selected subject immediately
    setSubjectDropdownKey(Date.now()); // force remount so dropdown can't hold previous value internally
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Create User Group</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/user_groups_dashboard")}
          >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSaveUserGroup}>
            SAVE
          </button>
        </div>
      </div>

      {/* GROUP INFORMATION */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>GROUP INFROMATION</label>
          </div>
          <div
            className="accordion-btn"
            onClick={toggleAccordionGroupInfo}
            style={{ cursor: "pointer" }}
            title={isOpenGroupInfo ? "Minimize" : "Expand"}
          >
            {isOpenGroupInfo ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenGroupInfo && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  <FormInputs
                    label="User Group Name"
                    type="text"
                    value={studentGroupName}
                    onChange={onGroupNameChange}
                    required
                    className={!groupNameValid ? "input-error" : ""}
                    inputClassName={!groupNameValid ? "input-error" : ""}
                    style={!groupNameValid ? { border: "1px solid red" } : {}}
                    maxLength={100}
                  />
                </div>

                <div className="item2">
                  <FormInputs
                    label="User Group Description"
                    type="text"
                    value={studentGroupDesc}
                    onChange={onGroupDescChange}
                    required
                    className={!groupDescValid ? "input-error" : ""}
                    inputClassName={!groupDescValid ? "input-error" : ""}
                    style={!groupDescValid ? { border: "1px solid red" } : {}}
                    maxLength={500}
                  />
                </div>

                <div className="item3">
                  <DropDown
                    label="Message Flag"
                    selected={selectedMessageFlag}
                    setSelected={setSelectedMessageFlag}
                    options={[
                      { id: 1, label: "True" },
                      { id: 0, label: "False" },
                    ]}
                    isRequired={true}
                  />
                </div>

                <div className="item4">
                  <DropDown
                    label="Email Flag"
                    selected={selectedEmailFlag}
                    setSelected={setSelectedEmailFlag}
                    options={[
                      { id: 1, label: "True" },
                      { id: 0, label: "False" },
                    ]}
                    isRequired={true}
                  />
                </div>

                <div className="item5">
                  <SingleSelectSearchDropdown
                    label="Select Group Owner Name"
                    width="100%"
                    singleSelect={true}
                    selected={selectedEmployeeCoordinator}
                    setSelected={setSelectedEmployeeCoordinator}
                    options={employeeOptions}
                    placeholder="Search and Select Group Owner Name..."
                    onSearchInputChange={fetchEmployeeCoordinator}
                    isRequired={true}
                  />
                </div>

                <div className="item6">
                  <FormInputs
                    label="Comments"
                    type="text"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    required={false}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* QUESTION REVIEWER GROUP */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION REVIEWER GROUP</label>
          </div>
          <div
            className="accordion-btn"
            onClick={toggleAccordionReviewerGroup}
            style={{ cursor: "pointer" }}
            title={isOpenReviewerGroup ? "Minimize" : "Expand"}
          >
            {isOpenReviewerGroup ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenReviewerGroup && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  <DropdownSelectedValue
                    label="Is this a Question Reviewer Group?"
                    selected={selectedReviewerGroup || 2}
                    setSelected={(value) => {
                      setSelectedReviewerGroup(value);
                      if (value === 2) {
                        setSelectedCourse(null);
                        setSelectedSubjects([]);
                        setSelectedReviewerType(null);
                        setSelectedReviewerLevel(null);
                        setReviewerDropdownKey(Date.now());
                        setSubjectDropdownKey(Date.now()); // also remount subject
                      }
                    }}
                    options={[
                      { label: "Yes", id: 1 },
                      { label: "No", id: 2 },
                    ]}
                    isRequired={true}
                  />
                </div>

                <div className="item2">
                  <DropDown
                    key={`course-${reviewerDropdownKey}`}
                    label="Course"
                    selected={
                      selectedReviewerGroup === 2 ? null : selectedCourse
                    }
                    setSelected={handleCourseSelect}
                    options={
                      Array.isArray(coursesdata)
                        ? coursesdata.map((course) => ({
                            label: course.course_name,
                            id: course.course_id,
                          }))
                        : []
                    }
                    isRequired={true}
                    disabled={selectedReviewerGroup === 2}
                  />
                </div>

                <div className="item3">
                  <DropDown
                    key={`subject-${subjectDropdownKey}`}
                    label="Subject"
                    selected={
                      selectedReviewerGroup === 2
                        ? null
                        : Array.isArray(selectedSubjects) &&
                          selectedSubjects.length > 0
                        ? selectedSubjects[0]
                        : null
                    }
                    setSelected={(val) => setSelectedSubjects(val ? [val] : [])}
                    options={
                      Array.isArray(subjects)
                        ? subjects.map((subj) => ({
                            label: subj.subject_name,
                            id: subj.subject_id,
                          }))
                        : []
                    }
                    isRequired={true}
                    disabled={selectedReviewerGroup === 2}
                  />
                </div>

                <div className="item4">
                  <DropDown
                    key={`reviewer-type-${reviewerDropdownKey}`}
                    label="HOD or Faculty Reviewer Group?"
                    selected={
                      selectedReviewerGroup === 2 ? null : selectedReviewerType
                    }
                    setSelected={(val) => {
                      // set the type normally
                      setSelectedReviewerType(val);
                      // clear level when HOD
                      if (val === 1) {
                        setSelectedReviewerLevel(null);
                      }
                      // << DO NOT call setReviewerDropdownKey here >>
                    }}
                    options={[
                      { label: "HOD", id: 1 },
                      { label: "Faculty", id: 2 },
                    ]}
                    isRequired={true}
                    disabled={selectedReviewerGroup === 2}
                  />
                </div>

                <div className="item5">
                  <DropDown
                    key={`reviewer-level-${reviewerDropdownKey}-${selectedReviewerType}`}
                    label="Reviewer Level"
                    selected={
                      selectedReviewerGroup === 2
                        ? null
                        : selectedReviewerType === 1
                        ? null
                        : selectedReviewerLevel
                    }
                    setSelected={setSelectedReviewerLevel}
                    options={[
                      { label: "1", id: 1 },
                      { label: "2", id: 2 },
                      { label: "3", id: 3 },
                    ]}
                    isRequired={true}
                    disabled={
                      selectedReviewerGroup === 2 || selectedReviewerType === 1
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* MANAGE EMPLOYEE */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>MANAGE EMPLOYEE</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
            {isOpenShareBranch ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenShareBranch && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="item1" style={{ marginLeft: "20px" }}>
                  <DropdownWithPagination
                    label="Add Employees"
                    width="100%"
                    selected={selectedEmployees}
                    setSelected={setSelectedEmployees}
                    onSearchInputChange={fetchEmployeesForGroup}
                    options={employeeSearchOptions}
                    isRequired={true}
                    showSelectAll={false}
                    itemsPerPage={4}
                  />
                </div>

                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossStudentGroup
                    headers={headers}
                    data={tableData}
                    searchPlaceholder="Search employees..."
                    selectedRows={selectedEmployees}
                    setSelectedRows={handleTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteRow}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdatedCreateUserGroup;
